import React, { useContext, useState, useEffect } from 'react';

import { Input, OTPInput, Button, ActionLink } from '../../atoms';
import { UserContext } from '../../../context';
import { AuthService } from '../../../services';

import { validateConfirmPassword } from '../../../utils/input.validator';
import { default as t } from '../../../utils/i18n';

import './reset-password.scss';

function ResetPassword({ updateStep }) {
  const { user, setUser } = useContext(UserContext);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otp, setOtp] = useState('');
  //const [attempted, setAttempted] = useState(1);
  const [disableButton, setDisableButton] = useState(true);

  // const [passwordValidationError, setPasswordValidationError] = useState(null);
  const [confirmValidationError, setConfirmValidationError] = useState(null);
  const [passwordValidationError, setPasswordValidationError] = useState(null);
  const [otpValidationError, setOtpValidationError] = useState(null);
  const [isMounted, setIsMounted] = useState(false);
  const [disableResentOtp, setDisableResentOtp] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {

    if (/^(?=.*\d)(?=.*[-+_!@#$%^&*., ?])(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(password) && confirmPassword === password && otp.toString().length === 6) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }


  }, [confirmPassword, password, otp]);

  // useEffect(() => {
  //   const passwordMatchError = validateConfirmPassword(password, confirmPassword);
  //   if (passwordMatchError) {
  //     return setPasswordValidationError(passwordMatchError);
  //   }
  // }, [confirmPassword]);

  const userInputValidate = () => {
    const val = (/^(?=.*\d)(?=.*[-+_!@#$%^&*., ?])(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(password) && (confirmPassword === password));
    //console.log(val);
    return val;
  }

  const handleOTPChange = otpValue => {
    setOtp(otpValue);
    setOtpValidationError(null);
    setPasswordValidationError(null);
    if (otpValue.toString().length === 6) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  };

  // const handleInputChange = e => {
  //   const { name, value } = e.target;
  //   setPasswordValidationError(null);
  //   setOtpValidationError(null);

  //   if (name === 'password') {
  //     setPassword(value);
  //   } else if (name === 'confirmPassword') {
  //     setConfirmPassword(value);
  //   }
  // };


  const handlePasswordChange = e => {
    const { name, value } = e.target;
    setPasswordValidationError(null);
    setConfirmValidationError(null);
    setOtpValidationError(null);
    if (name === 'password') {
      setPassword(value);
    }
  };

  const handlePasswordBlurChange = e => {
    const { name, value } = e.target;
    if (name === 'password') {
      setPassword(value);
      if (value === "") {
        setPasswordValidationError(t('error.CL_USR_000'));
      } else if (value && value != "" && !/^(?=.*\d)(?=.*[-+_!@#$%^&*., ?])(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(value)) {
        setPasswordValidationError(t('error.CL_USR_003'));
      }
    }
  }
  const handleConfirmChange = e => {
    const { name, value } = e.target;
    setConfirmValidationError(null);
    if (name === 'confirmPassword') {
      setConfirmPassword(value);
      if (password === value) {
        setConfirmPassword(value);
      }
      else {
        setConfirmValidationError(t('error.validation.passwordDoNotMatch'));
      }
    }

  };


  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const confirmForgotPasswordResponse = await AuthService.confirmForgotPassword(
        user.username.toLowerCase(),
        confirmPassword,
        otp
      );
      ////console.log(confirmForgotPasswordResponse);
      setUser(prevUserState => ({
        ...prevUserState,
        username: confirmForgotPasswordResponse?.data?.data?.username,
        userConfirmed: confirmForgotPasswordResponse?.data?.data?.userConfirmed,
      }));
      updateStep(3);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode === 'CL_USR_004' || dataCode === 'CL_USR_003') {
        setConfirmValidationError(t(`error.${dataCode}`));
      }
      else if (dataCode) {
        setOtpValidationError(t(`error.${dataCode}`));
        if (dataCode === 'CL_USR_008') {
          setDisableResentOtp(true);
        }
      }
      // setAttempted(prevValue => {
      //   if (prevValue < 5) return prevValue + 1;
      //   else return prevValue;
      // });
    }
  };

  const handleResendOTP = async () => {
    try {
      await AuthService.resendConfirmationCode(user.username.toLowerCase());
    } catch (error) {
      const errorCode = error.data?.data?.code;
      if (errorCode) {
        setOtpValidationError(t(`error.${errorCode}`));
      }
    }
  };

  const backtoStep1 = e => {
    e.preventDefault();
    localStorage.removeItem('user');
    setUser({
      username: null,
      name: null,
      tokens: {},
      userConfirmed: null,
      authenticated: null,
      isVerifyOtp: false,
      timestamp: null,
      insights:null
    });
    updateStep(1);
  }

  const checkupperCase = e => {
    var pattern = new RegExp(
      "^(?=.*[A-Z]).+$"
    );
    return pattern.test(e);
  }
  const checkNumeric = e => {
    var pattern = new RegExp(
      "^(?=.*\\d).+$"
    );
    return pattern.test(e);
  }
  const checkSpecialChar = e => {
    var pattern = new RegExp(
      "^(?=.*[-+_!@#$%^&*., ?]).+$"
    );
    return pattern.test(e);
  }

  if (!isMounted) return null;

  return (
    <div className="step2__card-container">
      <p className="step2__heading">
        {t('signup.step2.heading')} <span className="step2__heading-username">{user.name}</span>
      </p>
      <p className="step2__heading-email">({user.username})</p>
      <p className="step2__subheading">{t('forgot.step2.subheading')}</p>
      <div className="step2__password-policy">
        <p className="step2__password-policy-title">{t('signup.step2.passwordPolicyTitle')}:</p>
        <ul>
          <li>
            {!checkupperCase(password) && (<i className="fas fa-arrow-right"></i>)}
            {checkupperCase(password) && (<i className="fas fa-check check"></i>)}
            {t('signup.step2.passwordPolicy1')}</li>
          <li>
            {!checkNumeric(password) && (<i className="fas fa-arrow-right"></i>)}
            {checkNumeric(password) && (<i className="fas fa-check check"></i>)}
            {t('signup.step2.passwordPolicy2')}</li>
          <li>
            {!checkSpecialChar(password) && (<i className="fas fa-arrow-right"></i>)}
            {checkSpecialChar(password) && (<i className="fas fa-check check"></i>)}
            {t('signup.step2.passwordPolicy3')}</li>
        </ul>
      </div>

      <div className="step2__input-form-group">
        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <Input
              labelValue={t('user.input.label.password')}
              name="password"
              fieldType="password"
              placeholder={t('user.input.placeholder.enterPassword')}
              handleChange={handlePasswordChange}
              onBlurChange={handlePasswordBlurChange}
              errorMessage={passwordValidationError}
              value={password}
            />

            <Input
              labelValue={t('user.input.label.confirmPassword')}
              name="confirmPassword"
              fieldType="password"
              placeholder={t('user.input.placeholder.reEnterPassword')}
              handleChange={handleConfirmChange}
              onBlurChange={handleConfirmChange}
              errorMessage={confirmValidationError}
              value={confirmPassword}
            />
            <div className={`otp-container ${!userInputValidate() ? "disable" : ""}`}>
              <div className="input-otp-details">
                <h4 className="input-otp-details--header">{t('forgot.step2.otp.header')}</h4>
                <p className="input-otp-details--body">{t('forgot.step2.otp.body')}</p>
                <p className="input-otp-details--resendotp">{t('signup.step3.footer')}
                  <ActionLink
                    disabled={disableResentOtp}
                    anchor={true}
                    target={false}
                    value={t('user.link.resendOTP')}
                    handleClick={handleResendOTP}
                  />
                </p>
              </div>

              <OTPInput
                autoFocus
                name="otp"
                length={6}
                onChangeOTP={handleOTPChange}
                errorMessage={otpValidationError}
                disabled={!userInputValidate()}
              />
           
            <div className="btn-container">
              <Button
                type="submit"
                name="submit"
                label={t('forgot.step2.button.resetPassword')}
                disabled={disableButton}
              />
            </div>
            </div>
          </div>
        </form>
      </div>
      <div className="step2__footer">
        <ActionLink anchor={true} value={`< ${t('forgot.common.backLink')}`} handleClick={backtoStep1} />
        {/* <ActionLink value={t('user.buttonText.back')} redirectTo="/signIn" /> */}
        {/* <ActionLink
         disabled={disableResentOtp}
          anchor={true}
          target={false}
          value={t('user.link.resendOTP')}
          handleClick={handleResendOTP}
        /> */}
      </div>
    </div>
  );
}

export default ResetPassword;
